import CrudRepository from './CrudRepository'
export default class FooterAppsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/app/web')
  }
}
